enum OrderType {
  NEW_BOXES = "NEW_BOXES",
  CLEAN_BOXES = "CLEAN_BOXES",
  DIRTY_BOXES = "DIRTY_BOXES"
}

export default OrderType;
